import React from "react";
import { VariantProps } from "..";
import MapOverrideEnabled from "./MapOverrideEnabled";
import MapOverrideDisabled from "./MapOverrideDisabled";

const H = ({ mapPrice, selectedProduct }: VariantProps) => {
  const getOversizedPriceStyle = (oversizedPrice: number) => {
    if (oversizedPrice >= 100000) {
      return "price--oversized-mega";
    }
    if (oversizedPrice >= 10000) {
      return "price--oversized";
    }
    return "";
  };

  // showMapprice enabled
  return (
    <div className="map map-override mapH">
      <div className="map map-override map--login">
        <div className="map__group">
          {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? (
            <MapOverrideEnabled
              {...{
                price: selectedProduct.price,
                mapPrice,
                overSizedPriceStyle: getOversizedPriceStyle(mapPrice),
              }}
            />
          ) : (
            <MapOverrideDisabled
              {...{
                price: selectedProduct.price,
                mapPrice,
                overSizedPriceStyle: getOversizedPriceStyle(mapPrice),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default H;
